import { Stack, SxProps, Typography, useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { COLORS } from '@/styles/tokens/colors';
import { zIndexes } from '@/styles/zIndexes';

interface SelectItemGroupLabelProps {
  label?: React.ReactNode;
  sx?: SxProps<Theme>;
}

// this is used to label a group of options in a select
export function SelectItemGroupLabel({
  label,
  sx = {},
}: SelectItemGroupLabelProps) {
  const theme = useTheme();

  if (!label) {
    return (
      <Stack
        justifyContent="center"
        height={theme.spacing(1)}
        sx={sx}
        component="div"
        role="separator"
      >
        <Stack bgcolor={COLORS.GRAY[200]} height="1px">
          &nbsp;
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack
      justifyContent="end"
      sx={{
        height: theme.spacing(4.5),
        // this is to make the label stick to the top of the select input when the header
        // is scrolled past, so the user retains context of what section they're in
        position: 'sticky',
        top: theme.spacing(-0.5),
        zIndex: zIndexes.MENU,
        ...sx,
      }}
      component="div"
    >
      <Stack
        bgcolor={theme.palette.background.paper}
        height={theme.spacing(4.5)}
        justifyContent="center"
        px={theme.spacing(1.5)}
        py={theme.spacing(1.25)}
        sx={{ '.MuiMenu-list &': { px: 2 } }}
      >
        <Typography variant="eyebrow-xs" component="p">
          {label}
        </Typography>
      </Stack>
    </Stack>
  );
}
